// import Vue from 'vue'
// import consts from "@/consts"
// import range from "lodash/range";
// import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
// const changedField = 'changed__time';

// const collator = new Intl.Collator();
// const sortByName = function (a, b) {
//     let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
//     if (cmp) {
//         return cmp;
//     }
//     return a?.time?.utc - b.a?.time?.utc;
// }

export default {
    state: {
        shipmentsStatistics_index: [],
        shipmentsStatistics: [],
    },
    actions: {
        fetchShipmentStatistic/*all*/({dispatch, /*commit,*/ getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.period) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipmentStatistic', args, time: Date.now() / 1000})

                //const params = getApiProps('shipmentsStatistics', args)
                this.$api.shipmentsStatistics.shipmentsStatistics(args.period, {...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response?.data?.error && !response?.data?.errors) {
                            //commit('updateShipmentsStatistics', response.data)
                            resolve(response)
                        } else {
                            resolve(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentStatistic', args, inprogress: false})
                    });
            })
        },
    },
    mutations: {
    },
    getters: {
    }
}
